/**
 * Prints a file blob (PDF, image, ...) without navigating away from the current
 * page. The blob is rendered in a hidden iframe and the browser print dialog is
 * triggered for its content. The iframe and object URL are cleaned up once the
 * print dialog is closed.
 */
export const printBlob = (blob: Blob): void => {
	const url = URL.createObjectURL(blob);
	const iframe = document.createElement('iframe');
	iframe.style.position = 'fixed';
	iframe.style.right = '0';
	iframe.style.bottom = '0';
	iframe.style.width = '0';
	iframe.style.height = '0';
	iframe.style.border = '0';

	const cleanup = () => {
		URL.revokeObjectURL(url);
		iframe.remove();
	};

	iframe.onload = () => {
		const contentWindow = iframe.contentWindow;

		if (!contentWindow) {
			cleanup();
			return;
		}

		contentWindow.onafterprint = cleanup;
		contentWindow.focus();
		contentWindow.print();
	};

	iframe.src = url;
	document.body.appendChild(iframe);
};
